import { getRootUrl } from '@share-a-cart/shared-utils';

declare global {
  interface Window {
    /** Set by EJS shells from the server's getRootUrl() for this deployment. */
    SAC_ROOT_URL?: string;
  }
}

/**
 * Canonical origin for this deployment in the browser.
 * Prefer the server-published value so Vite's production-mode bundle still
 * resolves staging to cart-a-share.com when the HTML was rendered on staging.
 */
export function clientRootUrl(): string {
  if (typeof window !== 'undefined') {
    const fromShell = window.SAC_ROOT_URL;
    if (typeof fromShell === 'string' && fromShell.trim()) {
      return fromShell.replace(/\/$/, '');
    }
  }
  return getRootUrl();
}

/** Streamable HTTP MCP endpoint for this deployment. */
export function mcpEndpointUrl(): string {
  return `${clientRootUrl()}/mcp`;
}

/** Docs are authored against production; rewrite so staging copies the right host. */
export function localizeMcpUrls(text: string): string {
  return text.replaceAll('https://share-a-cart.com/mcp', mcpEndpointUrl());
}
